import { useEffect, useRef } from 'react';
import { useAds } from '@/ads/AdsContext';

interface AdSlotProps {
  slot: string | undefined;
}

/**
 * Renders a responsive AdSense unit when both client and slot ids are
 * configured. Consent is handled by Google's CMP, not by this component.
 */
export function AdSlot({ slot }: AdSlotProps) {
  const { client } = useAds();
  const pushed = useRef(false);

  useEffect(() => {
    if (client && slot && !pushed.current) {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        pushed.current = true;
      } catch {
        // AdSense not ready yet; will retry on next mount.
      }
    }
  }, [client, slot]);

  if (!client || !slot) return null;

  return (
    <ins
      className="adsbygoogle"
      style={{ display: 'block', textAlign: 'center', maxWidth: 728, maxHeight: 250, margin: '0 auto' }}
      data-ad-client={client}
      data-ad-slot={slot}
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  );
}
